<template>
  <span>
    <router-link
      v-if="url"
      :to="url"
      :class="{ 'text-gray': customer.deleted && styled }"
      :title="customer.deleted ? '已删除' : customer.name"
      class="cus-link"
    >
      <slot v-if="$slots.content" name="content"></slot>
      <component v-else :is="element">{{ customer.name }} </component>
    </router-link>
    <span class="text-gray" v-else>{{ customer.name }}</span>
  </span>
</template>
<script>
const customerCategoryRouteMap = {
  0: '/dashboard/customers',
  1: '/dashboard/ordinary_customers',
  2: '/dashboard/authorized_customers',
  3: '/dashboard/oem_customers',
  6: '/dashboard/final_customers',
  7: '/dashboard/other_customers',
}

import store from '@/store/store'
export default {
  props: {
    customer: {
      type: Object,
      default: function () {
        return {
          id: 0,
          name: '',
          deleted: 0,
        }
      },
    },
    dealer: {
      type: Boolean,
      default: true,
    },
    styled: {
      type: Boolean,
      default: true,
    },
    repeat: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    url() {
      if (this.repeat) {
        return `/dashboard/customers/repeat/${this.customer.id}`
      } else if (this.customer.deleted) {
        return `/dashboard/customers/deleted/${this.customer.id}`
      } else {
        let category = this.customer.category
          ? this.customer.category
          : this.customer.category_id

        //如果是中间商不跳分类详情页
        if (store.state.userInfo.dealer_id > 0) {
          if (category != 6) {
            return ''
          }
          category = 0
        }

        let id = this.customer.category
          ? this.customer.id
          : this.customer.twin_id
        return `${customerCategoryRouteMap[category]}/${id}`
        // return (
        //   '/dashboard/customers/' +
        //   (this.customer.deleted ? 'deleted/' : '') +
        //   this.customer.id
        // )
      }
    },
    element() {
      if (this.customer.deleted && this.styled) {
        return 'del'
      }
      return 'span'
    },
  },
}
</script>

<style scoped>
.cus-link {
  display: inline-block;
  line-height: 1.4em;
}
</style>